module.exports = __webpack_public_path__ + "assets/img/header_text2.811fbe40.svg";